export default __webpack_public_path__ + "static/media/t42.6902e6aa.jpg";